import { useLocalizable } from '@contexts/LocalizableContext'
import {
  Affix,
  Flex,
  Segmented,
  SegmentedProps,
  Select,
  SelectProps,
} from 'antd'
import { useEffect, useState } from 'react'
import {
  langList,
  langsAsFlagOptions,
  langsAsOptions,
} from '../../factories/Utils'

interface Props {
  type?: 'select' | 'segment' | 'floating'
  selectProps?: Omit<SelectProps, 'options'>
  segmentedProps?: Omit<SegmentedProps, 'options'>
}

export const LangSelector = ({
  type = 'select',
  selectProps,
  segmentedProps,
}: Props) => {
  const localizable = useLocalizable()

  if (!localizable) {
    throw new Error('LangSelector must be used within Localizable')
  }
  const [isFixed, setIsFixed] = useState<boolean | undefined>(false)
  useEffect(() => localizable.registerSelector(), [localizable])

  if (type === 'floating') {
    return (
      <Affix
        offsetTop={120}
        style={{ zIndex: 25 }}
        onChange={(affixed) => setIsFixed(affixed)}
      >
        <Flex justify="end">
          <Flex
            style={{
              filter: isFixed
                ? 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4))'
                : 'none',
              transition: 'width 0.3s ease',
            }}
          >
            <Segmented
              {...segmentedProps}
              defaultValue={langList[0].code}
              value={localizable.langCode}
              options={isFixed ? langsAsOptions : langsAsFlagOptions}
              onChange={(value) => localizable.setLangCode(value)}
            />
          </Flex>
        </Flex>
      </Affix>
    )
  }

  if (type === 'segment')
    return (
      <Segmented
        block
        {...segmentedProps}
        defaultValue={langList[0].code}
        value={localizable.langCode}
        options={langsAsOptions}
        onChange={(value) => localizable.setLangCode(value)}
      />
    )

  return (
    <Select
      {...selectProps}
      defaultValue={langList[0]}
      value={localizable.langCode}
      onChange={(value) => localizable.setLangCode(value)}
      options={langsAsOptions}
    />
  )
}

export type LangSelectorType = { LangSelector: typeof LangSelector }
